import React, { forwardRef, useEffect, useState } from 'react'
import axios from '../axios';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import Delete from '@mui/icons-material/Delete';
import Info from '@mui/icons-material/Info';
import { Checkbox, Chip, FormControl, FormHelperText, IconButton, Input, InputLabel, InputAdornment } from '@mui/material';
import FormGroup from '@mui/material/FormGroup';
import { MenuItem } from '@mui/material';
import { useStateValue } from '../StateProvider';
import { actionTypes } from '../reducer';
// import { red } from '@mui/material/colors';
import { statesArr } from "../helpers/constantVariables";
import { useInput, NumberFormatCustom, TextMaskCustom, TextMaskCustomSSN, TextMaskCustomDate, TextMaskCustomPhone, TextMaskCustomTaxID, TextMaskCustomZipCode, TextMaskCustom0to99, TextMaskCustomPercent, TextMaskCustomMCDOT, TextMaskCustomYear, TextMaskCustomDateNoMax } from "../hooks/inputHook";
import StepButtons from '../components/StepButtons';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import { RedeemRounded, Remove, Visibility, VisibilityOff } from '@mui/icons-material';
import Tab from '@mui/material/Tab';
import { DatePicker } from '@mui/lab'
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import moment from 'moment';
import { fieldValidationDriversLicense, fieldValidationLegalAge, fieldValidationOwnerMCDOTOptional, fieldValidationAmount, fieldValidationTaxID, fieldValidationWebsite, fieldValidation, fieldValidationPhone, fieldValidationEmail, fieldValidationSSN, fieldValidationLicenseNum, fieldValidationZipCode, fieldValidation0to99, fieldValidationFloat, fieldValidationMCDOT, fieldValidationDate } from "../validators/fieldValidation"
import CloseIcon from '@mui/icons-material/Close';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Grid container item
      textAlign="left"
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Grid xs={6} columnSpacing={{ xs: 2, sm: 3, md: 4 }} paddingLeft={0} paddingRight={4} container item style={{ borderRadius: '10px', boxShadow: '0px 0px 3px #888888', marginTop: '20px', marginLeft: "0px", paddingBottom: "20px", paddingTop: "20px", background: 'white' }}>
          <>{children}</>
        </Grid>
      )}
    </Grid>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

function Equipment({ },ref) {
  const [{ applicantDetails, activeStep }, dispatch] = useStateValue();
  const [value, setValue] = useState(0);
  const [equipmentValidate, setEquipmentValidate] = useState(false);
  const [open, setOpen] = useState(false);
  const [equipments, setEquipments] = useState(applicantDetails?.equipments ? applicantDetails?.equipments : [
    {
      equip_type: '',
      equip_inv_amount: '',
    }
  ]);

  const handleChangeEquipment = (index, event) => {
    const values = [...equipments];
    values[index][event.target.name] = event.target.value;
    setEquipments(values);
  }

  const handleChangeEquipType = (index, event) => {
    const values = [...equipments];
    values[index][event.target.name] = event.target.value;
    setEquipments(values);
  }

  const handleChangeEquipmentDate = (index, name, newValue) => {
    const values = [...equipments];
    values[index][name] = newValue;
    setEquipments(values);
  }

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleRemoveEquipment = (i) => {
    let filteredEquipments = equipments.filter((equipment, index) => index !== i)
    setEquipments(filteredEquipments);
    setValue(value - 1);
    handleClose();
  }

  const onUpdateBasicInfo = () => {
    let validation = validate();
    dispatch({
      type: actionTypes.SET_SUBMIT_APPLICANT_DETAILS,
      applicantDetails: {
        ...applicantDetails,
        equipments
      }
    });
    return validation;
  }

  const validate = () => {
    let validateSuccess = { error: false, msg: '' }
    let success = {}
    for (var i = 0; i < equipments?.length; i++) {
        success = fieldValidation(equipments[i].equip_type, `Equipment ${i + 1} Piece of Equipment`);
        if (success.error) return success;
        success = fieldValidation(equipments[i].equip_inv_amount, `Equipment ${i + 1} Invoice Amount`);
        if (success.error) return success;
    }
    return validateSuccess;
  }

  const handleAddEquipment = () => {
    setEquipments([...equipments,
    {
      equip_type: '',
      equip_inv_amount: '',
    },]);
    setValue(equipments?.length);
  }

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      <Grid item container textAlign="left" columnSpacing={{ xs: 2, sm: 3, md: 4 }}>
        <Grid textAlign="left" item xs={12}>
          <Typography color={"#616365"} borderBottom={"3px solid #0ea723"} variant="h5" gutterBottom component="div">
            Equipment
          </Typography>
        </Grid>
        <Grid item xs={12} marginTop={2}>
          <Typography marginTop={0} paddingTop={0} variant="subtitle1" component="div" >
            Collateral age restrictions: We will consider financing trucks that
            are three years old and newer and trailers that are five years old
            and newer.
          </Typography>
        </Grid>
        <Grid item xs={12} marginTop={2}>
          <Tabs TabIndicatorProps={{ style: { background: !equipmentValidate ? '#F8FBFD' : '#DFA79B', boxShadow: '0px 0px 3px #888888' } }} value={value} onChange={handleChange} aria-label="basic tabs example">
            {equipments.map((equipment, index) => (
              <Tab sx={{
                bgcolor: !equipmentValidate ? '#F8FBFD' : '#DFA79B',
              }} label={`${`Equipment - ${index + 1}`}`} {...a11yProps(0)} />
            ))}
          </Tabs>
        </Grid>
        {equipments.map((equipment, index) =>(
          <TabPanel value={value} index={index}>
            <Grid item xs={12}>
              <Grid sx={{ fontSize: '14px', margin: 'auto', display: { xs: 'none', md: 'block' } }} item xs={12} textAlign="right">
                <Button size="small" color="error" endIcon={<Delete />} onClick={handleClickOpen} >Remove Equipment</Button>
              </Grid>
              <Grid sx={{ display: { xs: 'block', sm: 'none' } }} item xs={12} md={6} lg={6} marginTop={'20px'} xl={6} textAlign="right">
                <Button size="small" style={{ fontSize: '12px', textAlign: 'right' }} color="error" startIcon={<Delete />} onClick={handleClickOpen} >Remove Equipment</Button>
              </Grid>
              <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                <DialogTitle id="alert-dialog-title">
                  {"Remove Equipment"}
                </DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                    Are you sure you want to remove this Equipment?
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleClose}>Cancel</Button>
                  <Button onClick={() => handleRemoveEquipment(index)}>
                    Yes
                  </Button>
                </DialogActions>
              </Dialog>
            </Grid>
            <Grid textAlign="left" item xs={12}>
              <Grid container item columnSpacing={{ xs: 2, sm: 3, md: 4 }}>
                <Grid item xs={12} md={2} lg={2} xl={2}>
                  <Typography marginTop={2} color={equipment.equip_type ? "#616365" : "#c02424"} variant="subtitle1" component="div">
                    Equipment:
                  </Typography>
                </Grid>
                <Grid item xs={12} md={4} lg={4} xl={4}>
                  <RadioGroup
                    row
                    aria-labelledby="demo-form-control-label-placement"
                    name="equip_type"
                    required={true}
                    sx={"margin-top:10px"}
                    value={equipment.equip_type}
                    onChange={event => handleChangeEquipType(index, event)}
                  >
                    <FormControlLabel value="Truck" control={<Radio />} label="Truck" />
                    <FormControlLabel value="Trailer" control={<Radio />} label="Trailer" />
                  </RadioGroup>
                </Grid>
                <Grid item xs={12} md={6} lg={6} xl={6}>
                  <FormControl variant="standard" margin="normal" fullWidth>
                    <InputLabel htmlFor="formatted-text-mask-input">Invoice Amount</InputLabel>
                    <Input
                      startAdornment={<InputAdornment position="start">$</InputAdornment>}
                      type="number"
                      value={equipment.equip_inv_amount}
                      error={fieldValidation(equipment.equip_inv_amount, "Invoice Amount").error}
                      helperText={fieldValidation(equipment.equip_inv_amount, "Invoice Amount").msg}
                      name="equip_inv_amount"
                      id="equip_inv_amount"
                      onChange={event => handleChangeEquipment(index, event)}
                    />
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
          </TabPanel>
        ))}
        <Grid textAlign={'right'} item xs={12} marginTop={3}>
          <Button sx={{ backgroundColor: '#3f51b5' }} size="medium" variant="contained" endIcon={<AddIcon />} onClick={() => handleAddEquipment()}>Add Equipment</Button>
        </Grid>
      </Grid>
      <StepButtons updateInfo={onUpdateBasicInfo} ref={ref} />
    </>
  )
}

export default forwardRef(Equipment)